export const TELEGRAM_CHAT_PAGE_LIMIT = 50;
